import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de vitesse - Comment calculer la vitesse";
const DESCRIPTION =
  "Calculatrice de vitesse - Comment calculer la vitesse. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "velocity, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/velocity";

function VelocityCalculator() {
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState("");
  const [velocity, setVelocity] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!distance || !time) {
      setError("Veuillez entrer la distance et le temps correctement");
      setVelocity("");
      return;
    }
    const distanceValue = parseFloat(distance);
    const timeValue = parseFloat(time);
    if (isNaN(distanceValue) || isNaN(timeValue) || timeValue <= 0) {
      setError("Veuillez entrer des valeurs correctes et positives pour la distance et le temps");
      setVelocity("");
      return;
    }
    const velocityValue = distanceValue / timeValue;
    setVelocity(velocityValue.toFixed(2));
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />       
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice vous aide à calculer la vitesse en fonction de la 
                  distance et du temps. Pour calculer la vitesse, entrez la distance 
                  parcourue (en kilomètres) et le temps (en heures).
                </p>
                <p>La formule de calcul de la vitesse est:</p>
                <p>
                  <b>
                    Vitesse (km/h) = Distance (km) / Temps (h)
                  </b>
                </p>
                <p>
                  Après avoir entré les valeurs appropriées, cliquez sur le bouton 
                  "Calculer la vitesse" pour obtenir le résultat.
                </p>
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div>
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label" style={{marginRight: "10px"}}>
                          Distance (kilomètres)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label" style={{marginRight: "10px"}}>Temps (heure)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer la vitesse
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur: {error}
                      </p>
                    ) : (
                      <>
                        {velocity !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Vitesse (km/h): {velocity}
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />         
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
    </div>
  );
}

export default VelocityCalculator;
